import { memo, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Badge, Text } from '@leroy-merlin-br/backyard-react-ui'

import formatPriceToBRL from 'reactUtils/formatPriceToBRL'

import { getShipmentMessage } from 'catalog/utils/shipments-dictionary'

import * as S from './styled'

const ShipmentPrice = ({ modality, cost, deadline, errorStatus }) => {
  const { deadlineMessage } = getShipmentMessage(modality, deadline)

  if (errorStatus || !modality) {
    return <S.ShipmentError>Confira o frete no carrinho.</S.ShipmentError>
  }

  const valueElement = cost === 0
    ? <Badge>Frete grátis</Badge>
    : <Fragment> + {formatPriceToBRL(cost)}</Fragment>

  return (
    <Fragment>
      {valueElement}
      {' - '}{deadlineMessage.prefix}{' '}
      <Text size="kilo" as="strong" bold noMargin>
        {deadlineMessage.main}
      </Text>
    </Fragment>
  )
}

ShipmentPrice.propTypes = {
  modality: PropTypes.string,
  cost: PropTypes.number,
  deadline: PropTypes.number,
  errorStatus: PropTypes.number.isRequired
}

export default memo(ShipmentPrice)
